import { render, staticRenderFns } from "./noneLayout.vue?vue&type=template&id=1ada6561&scoped=true"
import script from "./noneLayout.vue?vue&type=script&lang=js"
export * from "./noneLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ada6561",
  null
  
)

export default component.exports